<template>
  <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
    <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
      <h2 class="text-xl font-bold mb-4 text-gray-800">Add Item</h2>
      <form @submit.prevent="submitItem" enctype="multipart/form-data">
        <input v-model="item.name" class="w-full p-2 border rounded-lg mb-4" placeholder="Item Name" required />
        <input v-model="item.description" class="w-full p-2 border rounded-lg mb-4" placeholder="Item Description" required />
        <input v-model="item.unit" class="w-full p-2 border rounded-lg mb-4" placeholder="Eg. Kg, Liters, Pieces,..." required />
        <input v-model="item.quantity" type="number" class="w-full p-2 border rounded-lg mb-4" placeholder="Quantity" required />
        <input v-model="item.price" type="number" class="w-full p-2 border rounded-lg mb-4" placeholder="Price" min="0" required />

        <!-- Category Dropdown -->
        <select v-model="item.category" class="w-full p-2 border rounded-lg mb-4" required>
          <option disabled value="">Select a Category</option>
          <option v-for="category in categories" :key="category" :value="category">{{ category.name }}</option>
        </select>

        <!-- File Input for Image Upload -->
        <input type="file" @change="handleImageUpload" accept="image/*" class="w-full p-2 border rounded-lg mb-4" required />

        <!-- Submit Button -->
        <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Add Item</button>
      </form>

      <!-- Cancel Button -->
      <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      item: {
        name: '',
        description: '',
        unit: '',
        quantity: '',
        price: '',
        filename: '',
        category: '',
        image : ''
      },
    };
  },
  async mounted(){
    await this.fetchCategories()
  },
  computed: {
    ...mapState('categories', {
      categories: state => state.categories,
    })
  },
  methods: {
    ...mapActions('items', {
      addItem : 'addItem'
    }),
    ...mapActions('categories',{
      fetchCategories : 'fetchCategories'
    }),
    handleImageUpload(event) {
      const file = event.target.files[0];
      this.item.image = file; // Store the selected file in the item object
    },
    submitItem() {
      const formData = new FormData();
      formData.append('name', this.item.name);
      formData.append('description', this.item.description);
      formData.append('unit', this.item.unit);
      formData.append('quantity', this.item.quantity);
      formData.append('price', this.item.price);
      formData.append('category', this.item.category.id);
      formData.append('image', this.item.image); // Attach the image file
      this.addItem(formData);
      this.$emit('addItem', this.item);
      this.closeModal();
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>